export default function	isYouTubeUrl(url) {
	// eslint-disable-next-line max-len
	const youtubeRgx = /^(?:https?:\/\/)?(?:www\.)?(?:youtu\.be\/|youtube\.com\/(?:embed\/|watch\?v=|watch\?.+&v=))([^#&?]*).*/;
	const isYoutubeUrl = youtubeRgx.test(url);
	const matchYoutubeUrl = url.match(youtubeRgx);
	if (isYoutubeUrl) {
		const youtubeVideoId = matchYoutubeUrl[ 1 ];
		if (youtubeVideoId) {
			return {
				video_id: youtubeVideoId,
			};
		}
	}
	return false;
}
